var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-list-item",
    {
      on: {
        click: function ($event) {
          return _vm.onClick()
        },
      },
    },
    [
      _vm.$wf.isMdUp
        ? _c(
            "w-list-item-text",
            [
              _c(
                "w-row",
                [
                  _c(
                    "w-col",
                    {
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: 3 },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.saleTypeName) +
                          " " +
                          _vm._s(_vm.computedFriendlyId)
                      ),
                    ]
                  ),
                  _c(
                    "w-col",
                    {
                      staticClass: "status",
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: "2" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("localDate")(_vm.estimate.InvoiceDate)
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _c(
                    "w-col",
                    {
                      staticClass: "status",
                      style: { justifyContent: "center" },
                      attrs: { sm: "6", md: "2" },
                    },
                    [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm._f("localDate")(
                              _vm.isSigned
                                ? _vm.estimate.SignedOnDate
                                : _vm.estimate.ExpirationDate
                            )
                          ) +
                          " "
                      ),
                    ]
                  ),
                  _vm.showTotal && _vm.isSigned
                    ? _c(
                        "w-col",
                        {
                          style: { justifyContent: "center" },
                          attrs: { sm: "6", md: "2" },
                        },
                        [_vm._v(_vm._s(_vm.estimate.SignedBy))]
                      )
                    : _vm._e(),
                  _vm.showTotal && !_vm.isSigned
                    ? _c(
                        "w-col",
                        {
                          style: { justifyContent: "center" },
                          attrs: { sm: "6", md: "2" },
                        },
                        [
                          _vm._v(
                            "€ " +
                              _vm._s(
                                _vm._f("printHumanFloat")(
                                  _vm.estimate.TotalIncVAT
                                )
                              )
                          ),
                        ]
                      )
                    : _vm._e(),
                  _c("w-col", { attrs: { sm: "6", md: "3" } }, [
                    _c(
                      "div",
                      { style: { textAlign: "right" } },
                      [
                        !_vm.isSigned
                          ? _c(
                              "w-button",
                              {
                                directives: [
                                  {
                                    name: "tooltip",
                                    rawName: "v-tooltip",
                                    value: _vm.$ct("sign-tooltip"),
                                    expression: "$ct('sign-tooltip')",
                                  },
                                ],
                                staticClass: "mr",
                                attrs: { icon: "signature" },
                                on: {
                                  click: function ($event) {
                                    $event.stopPropagation()
                                    return _vm.sign()
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("common.uSign")) + " "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "w-button",
                          {
                            directives: [
                              {
                                name: "tooltip",
                                rawName: "v-tooltip",
                                value: _vm.$ct("download-tooltip"),
                                expression: "$ct('download-tooltip')",
                              },
                            ],
                            staticClass: "mts",
                            attrs: { icon: "file-pdf" },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.download()
                              },
                            },
                          },
                          [_vm._v(" " + _vm._s(_vm.$ct("download")) + " ")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _c(
            "div",
            { staticClass: "mobile" },
            [
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$ct("header.document"))),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm.saleTypeName) +
                          " " +
                          _vm._s(_vm.computedFriendlyId)
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label right" }, [
                      _vm._v(_vm._s(_vm.$ct("header.incl"))),
                    ]),
                    _c("div", { staticClass: "value right" }, [
                      _vm._v(
                        "€ " +
                          _vm._s(
                            _vm._f("printHumanFloat")(_vm.estimate.TotalIncVAT)
                          )
                      ),
                    ]),
                  ]),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(_vm._s(_vm.$ct("header.estimate-date"))),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm._f("localDate")(_vm.estimate.InvoiceDate))
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                ],
                1
              ),
              _c(
                "w-row",
                [
                  _c("div", { staticClass: "label-group" }, [
                    _c("div", { staticClass: "label" }, [
                      _vm._v(
                        _vm._s(_vm.$ct("header.estimate-expiration-date"))
                      ),
                    ]),
                    _c("div", { staticClass: "value" }, [
                      _vm._v(
                        _vm._s(_vm._f("localDate")(_vm.estimate.ExpirationDate))
                      ),
                    ]),
                  ]),
                  _c("w-spacer"),
                ],
                1
              ),
            ],
            1
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }